import React, { useEffect, useState } from 'react';
import { donePageLoading, setIsStreaming } from '../actions/offer';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory } from "react-router-dom"
import { logout } from "../actions/piano"
import { useTranslation } from "react-i18next";

function Unsubscribe(props) {
	const { t } = useTranslation();

	const [unsubscribeLastConfirmIsOpen, setUnsubscribeLastConfirmIsOpen] = useState(false);
	const [unsubscribeCompleteIsOpen, setUnsubscribeCompleteIsOpen] = useState(false);
	const [unsubscribeFailedIsOpen, setUnsubscribeFailedIsOpen] = useState(false);
	const [unsubscribeWarningAgreeCheckIsDisable, setUnsubscribeWarningAgreeCheckIsDisable] = useState(true);
	const [unsubscribeMessageWarning, setUnsubscribeMessageWarning] = useState('');
	const [unsubscribeMessageLastConfirm, setUnsubscribeMessageLastConfirm] = useState('');
	const [unsubscribeMessageComplete, setUnsubscribeMessageComplete] = useState('');
	const [unsubscribeMessageFailed, setUnsubscribeMessageFailed] = useState('');
	const [unsubscribeWarningCheckBoxIsDisable, setUnsubscribeWarningCheckBoxIsDisable] = useState(false);

	const history = useHistory();
	const rootPath = '/';
	const myPagePath = '/mypage';
	const cookieGetKeyUtp = '__utp';
	
	useEffect(() => {
		props.setIsStreaming(false);
		props.donePageLoading(true);
		// 各画面及びポップアップ文言を表示する
		setMessage();
	}, []);

	useEffect(() => {
		// メッセージ切り替え
		setMessage();
	}, [props.language]);

	useEffect(() => {
		// メッセージ切り替え
		setMessage();
		let unsubscribeWarningCheckBox = document.getElementById('unsubscribe-confirm');
		if (unsubscribeWarningCheckBox.checked) {
			unsubscribeWarningCheckBox.checked = false;
			//退会するボタンを非活性にする。
			setUnsubscribeWarningAgreeCheckIsDisable(true);
		}
	}, [props.language]);

	const setMessage = () => {
		try {
			const url = process.env.REACT_APP_API_DIR_URL + `v1/static/unsubscribe`;
			fetch(url)
			.then(response => response.json())
			.then(data => {
				//props.language en_US or ja_JP
				const warn = (props.language === 'ja_JP') ? '' + data.jp[0].warning : '' + data.en[0].warning ;
				const confirm = (props.language === 'ja_JP') ? '' + data.jp[0].confirm : '' + data.en[0].confirm ;
				const failed = (props.language === 'ja_JP') ? '' + data.jp[0].failed : '' + data.en[0].failed ;
				const complete = (props.language === 'ja_JP') ? '' + data.jp[0].complete : '' + data.en[0].complete ;
				getUnsubscribeMessageWarning(warn);
				setUnsubscribeMessageLastConfirm(confirm);
				setUnsubscribeMessageFailed(failed);
				getUnsubscribeMessageComplete(complete);
			})
			.catch(error => {
				console.log(error);
			});
		} catch (error) {
			console.error(error);
		}
	}

	// 退会注意事項ファイルからメッセージを取得
	const getUnsubscribeMessageWarning = (text) => {
		setUnsubscribeMessageWarning(text);
		setUnsubscribeWarningCheckBoxIsDisable(false);
	}

	// 退会処理完了ファイルからメッセージを取得
	const getUnsubscribeMessageComplete = (text) => {
		setUnsubscribeMessageComplete(text);
	}

	//退会注意事項画面:チェックボックス
	const onChangeUnsubscribeWarningAgreeCheck = () => {
		if (unsubscribeWarningAgreeCheckIsDisable) {
			//退会するボタンを活性にする。
			setUnsubscribeWarningAgreeCheckIsDisable(false);
		} else {
			//退会するボタンを非活性にする。
			setUnsubscribeWarningAgreeCheckIsDisable(true);
		}

	}

	//退会注意事項画面:退会するボタンクリック
	const onClickUnsubscribeWarningDoUnsubscribe = () => {
		//退会最終確認ポップアップを開く
		setUnsubscribeLastConfirmIsOpen(true);
	}

	//退会最終確認ポップアップ:退会しないボタンクリック
	const onClickUnsubscribeLastConfirmDoNotUnsubscribe = () => {
		//退会最終確認ポップアップを閉じる
		setUnsubscribeLastConfirmIsOpen(false);
	}
	//退会最終確認ポップアップ：退会するボタンクリック
	const onClickUnsubscribeLastConfirmDoUnsubscribe = () => {
		let utp = getCookie(cookieGetKeyUtp);
		let params = new URLSearchParams()
		params.append("jwt",utp)
		axios
			.post(
				process.env.REACT_APP_API_DIR_URL + `v1/user/delete`,params
			)
			.then(() => {
				//正常レスポンス
				props.logout(false);
				//退会最終確認ポップアップを閉じる
				setUnsubscribeLastConfirmIsOpen(false);
				//退会完了ポップアップを表示する
				setUnsubscribeCompleteIsOpen(true);

			})
			.catch(() => {
				//異常レスポンス
				//退会最終確認ポップアップを閉じる
				setUnsubscribeLastConfirmIsOpen(false);
				//退会処理失敗ポップアップを表示する
				setUnsubscribeFailedIsOpen(true);
			});
	}
	//退会完了ポップアップ:OKボタンクリック
	const onClickUnsubscribeCompleteOK = () => {
		//退会完了ポップアップを閉じる
		setUnsubscribeCompleteIsOpen(false);
		// トップページに遷移する
		history.push(rootPath);
	}

	//退会処理失敗ポップアップ:OKボタンクリック
	const onClickUnsubscribeFailedOK = () => {
		//退会完了ポップアップを閉じる
		setUnsubscribeCompleteIsOpen(false);
		// マイページに遷移する
		history.push(myPagePath);
	}

	function getCookie(cname) {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}


	return (
		<>
		<section className="unsubscribe" id="unsubscribe-basic">
			<style jsx="true">
				{`
				h2.common-title {padding-top: 3rem; font-size: 1.8rem; line-height:2rem; }
				h3.common-title {padding-top: 1rem; font-size: 1.2rem; line-height:2rem; }
				pre{ white-space: pre-wrap; }
				`}
			</style>
			<div className="unsubscribe__inner">

				<h1 className="common-title">{t("unsubscribe.title")}</h1>

				<section className="unsubscribe-section">
					<h2 className="unsubscribe-title">{t("unsubscribe.subTitle")}</h2>
					<div className="unsubscribe--textbox">
						<pre className="whitespace-pre-wrap">
							{unsubscribeMessageWarning}
						</pre>
					</div>
					<div className="unsubscribe--confirm">
						<input type="checkbox" id="unsubscribe-confirm" disabled={unsubscribeWarningCheckBoxIsDisable} onChange={onChangeUnsubscribeWarningAgreeCheck} /><label htmlFor="unsubscribe-confirm">{t("unsubscribe.checkboxAgreeText")}</label>
					</div>
					<div className="unsubscribe--footer">
						<button className="normal-button" type="button" disabled={unsubscribeWarningAgreeCheckIsDisable} onClick={onClickUnsubscribeWarningDoUnsubscribe} >{t("unsubscribe.submitButton")}</button>
					</div>
				</section>

			</div>
			{/* 退会最終確認 */}
			{unsubscribeLastConfirmIsOpen && (
				<React.Fragment>
					<div className="popup-overlay"></div>
					<section className="unsubscribe--popup">
						<div className="popup__base">
							<div className="popup__text">
								<h2 className="common-title">{t("unsubscribe.popupTitle")}</h2>
								<pre className="whitespace-pre-wrap">
									{unsubscribeMessageLastConfirm}
								</pre>
							</div>
							<div className="popup__footer">
								<button className="normal-button" onClick={onClickUnsubscribeLastConfirmDoNotUnsubscribe} >{t("unsubscribe.popupClearButton")}</button>
								<button className="normal-button attention" onClick={onClickUnsubscribeLastConfirmDoUnsubscribe} >{t("unsubscribe.popupSubmitButton")}</button>
							</div>
						</div>
					</section>
				</React.Fragment>
			)}
			{/* 退会成功 */}
			{unsubscribeCompleteIsOpen && (
				<React.Fragment>
					<div className="popup-overlay"></div>
					<section className="unsubscribe--popup">
						<div className="popup__base">
							<div className="popup__text">
								<h2 className="common-title">{t("unsubscribe.popupCompleteMsg")}</h2>
								<pre className="whitespace-pre-wrap">
									{unsubscribeMessageComplete}
								</pre>
							</div>
							<div className="popup__footer">
								<button className="normal-button" onClick={onClickUnsubscribeCompleteOK}>{t("unsubscribe.popupCompleteButton")}</button>
							</div>
						</div>
					</section>
				</React.Fragment>
			)}
			{/* 退会失敗 */}
			{unsubscribeFailedIsOpen && (
				<React.Fragment>
					<div className="popup-overlay"></div>
					<section className="unsubscribe--popup">
						<div className="popup__base">
							<div className="popup__text">
								<h2 className="common-title">{t("unsubscribe.popupFailMsg")}</h2>
								<pre className="whitespace-pre-wrap">
									{unsubscribeMessageFailed}
								</pre>
							</div>
							<div className="popup__footer">
								<button className="normal-button" onClick={onClickUnsubscribeFailedOK}>{t("unsubscribe.popupCompleteButton")}</button>
							</div>
						</div>
					</section>
				</React.Fragment>
			)}
		</section>
		</>
	);
}



const mapStateToProps = state => {
	return {
		language: state.piano.language,
		donePageLoading: state.offer.donePageLoading,
	};
};

const mapDispatchToProps = dispatch => ({
	setIsStreaming: state => dispatch(setIsStreaming(state)),
	donePageLoading: state => dispatch(donePageLoading(state)),
	logout: isToTop => dispatch(logout(isToTop)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
